import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Service } from "../../Service/ApiService";
import { CommonService } from "../../Service/CommonService";
import Spinner from "../Common/Spinner";
import ClearIcon from '@mui/icons-material/Clear';
import { Clear } from "@mui/icons-material";

interface ChildProps {
  suspendCompany: any;
  reloadTable: any;
}

const SuspendCompany: React.FC<ChildProps> = ({
  suspendCompany,
  reloadTable,
}) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (suspendCompany.length) {
      let c = suspendCompany.map((company: { email: any }) => {
        return company.email;
      });
    }
  }, [suspendCompany]);

  const handleSubmit = () => {
    setIsLoading(true);
    if (suspendCompany.length) {
      Service.suspendCompanyById(suspendCompany)
        .then((response) => {
          setIsLoading(false);
          CommonService.Toast.fire({
            title: "Account owner suspended successfully",
            icon: "success",
          });
          reloadTable();
        })
        .catch((error) => {
          setIsLoading(false);
          console.log(error);
        });
    }
    setIsLoading(false);
    handleClose();
  };

  return (
    <>
      <button className="primary-btn d-inline-flex me-1" onClick={handleShow}>
        <ClearIcon sx={{ me: 2 }} /> Suspend
        <span className="review--number text-secondary d-inline-flex align-items-center justify-content-center rounded-circle bg-white ms-2">
          {suspendCompany.length}
        </span>
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        className="modal__wd modal__wd--submitSellReq"
      >
        <Modal.Header className="flex-column align-items-start">
          <Modal.Title>Suspend Account Owner</Modal.Title>
          <p className="modal-text">
            Are you sure, you want to suspend this account owner?
          </p>
        </Modal.Header>
        <Modal.Footer className="justify-content-center bg-transparent">
          <div className="btn-group row d-flex justify-content-between w-100">
            <div className="col-6 ps-0">
              <Button
                className="secondary-btn w-100"
                onClick={handleClose}
                disabled={isLoading}
              >
                No
              </Button>
            </div>
            <div className="col-6 pe-0">
              <Button
                className="primary-btn w-100"
                onClick={handleSubmit}
                disabled={isLoading}
              >
                {isLoading && <Spinner />} Yes
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SuspendCompany;
